import { isProd, isSandbox, EnvName, isDev, isLocal } from '@utils/api';
import {
	ExperimentId,
	EXPERIMENTS_SESSION_KEY,
	EXPERIMENT_PREFIX,
	IEnv,
	IExperiment
} from './types';

const isOpen = (experimentEnv: IEnv, envId: EnvName, params?: string) =>
	(experimentEnv[envId] === true && params === 'true') ||
	experimentEnv[envId] === 'always' ||
	envId === EnvName.TEST;

const getEnv = (): EnvName => {
	const { PRODUCTION, SANDBOX, LOCAL, DEV, NONE } = EnvName;

	if (isProd()) {
		return PRODUCTION;
	}
	if (isSandbox()) {
		return SANDBOX;
	}
	if (isDev()) {
		return DEV;
	}
	if (isLocal()) {
		return LOCAL;
	}
	return NONE;
};

export const getUrlParams = () => {
	const queryString = window.location.search;
	return new URLSearchParams(queryString);
};

export const getUrlParam = (name: string) => {
	const params = getUrlParams();
	if (params.has(name)) {
		return params.get(name);
	}
	return null;
};

export const isExperimentOpen = (experimentId: ExperimentId) => {
	const urlParam = getUrlParam(
		`${EXPERIMENT_PREFIX}:${experimentId as string}`
	);

	const sessionExperiments = window?.sessionStorage?.getItem(
		EXPERIMENTS_SESSION_KEY
	);

	if (!sessionExperiments || sessionExperiments === null) {
		return false;
	}

	const parsed = JSON.parse(sessionExperiments);

	if (!Array.isArray(parsed)) {
		return false;
	}

	const filtered = parsed.filter(({ id }: IExperiment) => id === experimentId);

	if (!filtered.length) {
		return false;
	}

	const { env: experiemntEnv } = filtered[0];

	if (!experiemntEnv) {
		return false;
	}

	return isOpen(experiemntEnv, getEnv(), urlParam as string);
};
